/* eslint-disable @next/next/no-img-element */
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import CarouselWrapper from 'components/shared/Carousel/CarouselWrapper/CarouselWrapper';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { UIButton } from '../shared//UIButton.styles';
import {
  ExploreOpportunitiesBox,
  NoQuestionnaireBox,
  SQLableText,
} from './MyProfileQuestionnaire.style';
import { StCommonTypography } from '../shared/Container/Container.styles';

const MyProfileQuestionnaireCarousel = (props: any): JSX.Element => {
  const profileData = useSelector((state: RootState) => state.crProfile?.profileData);
  const studyQuestionnaireData = profileData?.studyQuestionnaireDetails || [];
  const theme = useTheme();
  const { sitecoreContext } = useSitecoreContext();
  const isMyProfilePage = sitecoreContext?.route?.fields?.isMyProfilePage;

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.backgroundColorType3.main,
        ...(isMyProfilePage && { borderTop: `2px solid ${theme.palette.neutral3.main}` }),
      }}
      id="CR-Questionaaire-carousel"
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          padding: '48px 41px',
          maxWidth: '1400px',
          marginInline: 'auto',
          gap: '26px',
        }}
      >
        <StCommonTypography
          sx={{
            textAlign: 'center',
            fontWeight: 600,
            fontSize: '32px',
            lineHeight: '24px',
            color: (theme) => theme.palette.neutral8.main,
            [theme.breakpoints.down('sm')]: {
              fontSize: '24px',
              ...(isMyProfilePage && studyQuestionnaireData?.length > 0 && { textAlign: 'start' }),
            },
          }}
        >
          <Text field={props?.fields?.sectionTitle} />
        </StCommonTypography>
        {studyQuestionnaireData?.length > 0 ? (
          <CarouselWrapper
            {...props}
            questionaaireList={studyQuestionnaireData}
            callerComponent="CR-Questionaaire"
          />
        ) : (
          <NoQuestionnaireBox>
            <SQLableText>{props?.fields?.noStudyText?.value}</SQLableText>
          </NoQuestionnaireBox>
        )}
        {props?.fields?.isExploreLinkVisible?.value && (
          <ExploreOpportunitiesBox>
            <UIButton variant={'text'} href={props?.fields?.exploreStudyLink?.value?.href || '#'}>
              {props?.fields?.exploreStudyLink?.value?.text}
              <img
                src={props?.fields?.exploreLinkIcon?.value?.src}
                alt={props?.fields?.exploreLinkIcon?.value?.alt}
              />
            </UIButton>
          </ExploreOpportunitiesBox>
        )}
      </Box>
    </Box>
  );
};

export default MyProfileQuestionnaireCarousel;
